import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import AppConfig from '../../config';

export const faqApi = createApi({
  reducerPath: 'faqApi',
  baseQuery: fetchBaseQuery({
    baseUrl: AppConfig.apiBaseUrl,
  }),
  endpoints: (builder) => ({
    getAllFaq: builder.query({
      query: () => '/api/faq/all',
    }),
  }),
});

export const { useGetAllFaqQuery } = faqApi;
